<template>
    <div class="inner-box">
        <!-- 구입상품입력추가 그리드 s.-->
        <div class="table-area">
            <div class="table-b">
                <div class="table-header">
                    <div class="table-name">
                        <h3 class="ico_table_name">{{ `구입상품입력추가` }}</h3>
                    </div>
                    <div class="btn-wrap btn-type1 clearfix">
                        <button class="btn-size btn-gray fl_left" @click="openModel" v-show="showSave">
                        <span class="btn-icon">
                            <i class="fas fa-save"></i>
                        </span>
                        추가
                        </button>
                        <button class="btn-size btn-gray fl_left" @click="deleteItem" v-show="showSave">
                        <span class="btn-icon">
                            <i class="fas fa-save"></i>
                        </span>
                        삭제
                        </button>
                    </div>
                    <div class="grid-tbl-box">
                        <ag-grid-vue 
                            ref="grid" 
                            :style="gridStyle"
                            class="ag-theme-alpine"
                            :enableRangeSelection="true"
                            :column-defs="columnDefs"
                            :grid-options="mainGridOptions"
                            :row-data="data"
                            :default-col-def="defaultColDef"
                            :framework-components="frameworkComponent"
                            @grid-ready="onReadyMain"
                            @cell-value-changed="onItemCellValueChange"
                            @cell-clicked="onItemCellClicked" />
                    </div>
                </div>
            </div>
        </div>
        <!-- 구입상품입력추가 그리드 e.-->

        <!-- 결제방법 선택 form s.-->
        <div class="table-area">
            <div class="table-b">
                <div class="el-search-form">

                    <el-form size="mini" label-width="80px">
                        <el-row :gutter="24">
                            <el-col :span="12">
                                <div class="sub-title">
                                    <div class="table-name">
                                        <h3 class="ico_table_name">{{ `결제방법` }}</h3>
                                    </div>
                                </div>
                                <el-row>
                                    <el-col>
                                        <el-form-item label="주문번호">
                                            <el-input type="text" v-model="form.orderId" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="24">
                                    <el-col :span="12">
                                        <el-form-item label="주문일시">
                                            <el-input type="text" v-model="form.orderDt" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="청구금액">
                                            <el-input type="text" v-model="form.orderAmt" readonly></el-input>
                                            <el-input type="text" v-model="orderAmt" v-show="false"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="24">
                                    <el-col :span="12">
                                        <el-form-item label="주문자명">
                                            <el-input type="text" v-model="form.orderCustNm"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-row>
                                            <el-form-item label="입금은행">
                                                <el-col :span="24">
                                                    <el-select v-model="form.payBank">
                                                        <el-option
                                                        v-for="item in payBankOpt"
                                                        :key="item.key"
                                                        :value="item.key"
                                                        :label="item.value">
                                                        </el-option>
                                                    </el-select>
                                                </el-col>
                                            </el-form-item>
                                        </el-row>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="24">
                                    <el-col :span="12">
                                        <el-form-item label="연락처">
                                            <el-input type="text" v-model="form.orderTelNo"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-row>
                                            <el-form-item label="계산서발행">
                                                <el-col :span="24">
                                                    <el-radio-group v-model="form.billYn">
                                                        <el-radio 
                                                            v-for="item in billYnRadio"
                                                            :key="item.key"
                                                            :label="item.value"
                                                            :value="item.key">
                                                        </el-radio>
                                                    </el-radio-group>
                                                </el-col>
                                            </el-form-item>
                                        </el-row>
                                    </el-col>
                                </el-row>
                                <div class="grid-content bg-purple"></div>
                            </el-col>
                            <el-col :span="12">
                                <div class="sub-title">
                                    <div class="table-name">
                                        <h3 class="ico_table_name">{{ `배송지` }}</h3>
                                    </div>
                                </div>
                                <el-row>
                                    <el-col>
                                        <el-form-item label="받을사람">
                                            <el-input type="text" v-model="form.deliveryNm"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="24">
                                    <el-col :span="12">
                                        <el-form-item label="전화번호">
                                            <el-input type="text" v-model="form.deliveryTelNo"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="핸드폰">
                                            <el-input type="text" v-model="form.deliveryHpNo"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="24">
                                    <el-col>
                                        <el-form-item label="주소">
                                            <el-row>
                                                <el-col>
                                                    <el-row>
                                                        <el-col :span="4">
                                                            <el-input type="text" v-model="form.zipCd1"></el-input>
                                                        </el-col>
                                                        <el-col :span="4">
                                                            <el-button type="primary" icon="el-icon-search" @click="addrOpenPopUp" v-show="showSave"></el-button>
                                                        </el-col>
                                                        <el-col :span="12">
                                                            <el-input type="text" v-model="form.addr1"></el-input>
                                                        </el-col>
                                                    </el-row>
                                                </el-col>
                                            </el-row>
                                            <el-row>
                                                <el-col>
                                                    <el-row :gutter="24">
                                                        <el-col :span="24">
                                                            <el-input type="text" v-model="form.addr2"></el-input>
                                                        </el-col>
                                                    </el-row>
                                                </el-col>
                                            </el-row>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>
        </div>
        <!-- 결제방법 선택 form e.-->

        <!-- 주문메모 text area s.-->
        <div class="table-area">
            <div class="table-b" style="margin-bottom: 0px;">
                <el-row :gutter="24">
                    <el-col>
                        <div class="sub-title">
                            <div class="table-name">
                                <h3 class="ico_table_name">{{ `주문메모` }}</h3>
                            </div>
                        </div>
                        <el-input
                        type="textarea"
                        :autosize="{ minRows: 4, maxRows: 6}"
                        placeholder="주문메모를 작성하세요."
                        v-model="form.memo">
                        </el-input>
                        <div class="grid-content bg-purple"></div>
                    </el-col>
                </el-row>
                <div><span class="wave">&nbsp;</span></div>
                <div class="btn-wrap btn-type1 clearfix">
                    <el-button type="primary" icon="el-icon-folder-checked" size="mini" @click="save" v-show="showSave">저장</el-button>
                </div>
            </div>
        </div>
        <!-- 주문메모 text area e.-->

        <!-- 주문상담이력 그리드 s.-->
        <div class="table-area" style="margin: 0;">
            <div class="table-b">
                <div class="table-header">
                    <div class="table-name">
                        <h3 class="ico_table_name">{{ `주문상담이력` }}</h3>
                    </div>
                    <div class="grid-tbl-box">
                        <ag-grid-vue 
                            ref="grid" 
                            :style="gridStyle"
                            class="ag-theme-alpine"
                            :enableRangeSelection="true"
                            :column-defs="subColumnDefs"
                            :grid-options="subGridOptions"
                            :row-data="subData"
                            :default-col-def="defaultColDef"
                            :framework-components="frameworkComponent"
                            @grid-ready="onReadySub"
                            @cell-clicked="onSubCellClicked" />
                    </div>
                </div>
            </div>
        </div>
        <!-- 주문상담이력 그리드 e.-->
    </div>
</template>

<script>
/**
 * * lodash.js
 */
import _ from 'lodash';
/**
 * * mixins
 */
import slip from '@/mixin/slip';
import common from '@/mixin/common';
import lucoms from '@/mixin/lucoms';

/**
 * * components
 */
import {AgGridVue} from 'ag-grid-vue';
import DatepickerCellRenderer from '@/components/agGrid/datepicker-cell-renderer';
import MaskEditCellRenderer from '@/components/agGrid/maskedit-cell-renderer';
import SelectCellRenderer from '@/components/agGrid/select-cell-renderer';
import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer';
import RadioCellRenderer from '@/components/agGrid/radio-cell-renderer';
import NumberInputCellRender from '@/components/agGrid/numberinput-cell-renderer';
import InputCellRender from '@/components/agGrid/input-cell-renderer';
import ButtonCellRenderer from '@/components/agGrid/button-cell-renderer';
import InvtItemSelect from '@/components/AS/OrderConsult/Modal/InvtItemSelect';

/**
 * * Modals for the order consult
 */
import OrderRead from '@/components/AS/OrderConsult/Modal/OrderRead';
/**
 * 콤마표시
 * @param {*} val 
 */
function comma(val){
    return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

/**
 * 객체내의 값 초기화
 */
 $.ObjectInitialize = function (obj) {
    let self = this;
    self.obj = obj;

    $.each(obj, function (item_name, item) {
        let datatype = $.type(item);

        if (datatype == "number")
            self.obj[item_name] = 0;   // 정수는 0 으로 초기화

        else if (datatype == "string")
            self.obj[item_name] = '';   // 문자는 '' 으로 초기화

        else if (datatype == "boolean")
            self.obj[item_name] = false;   // boolean 는 false 으로 초기화

        else if (datatype == "array")
            self.obj[item_name] = [];   // 배열은 [] 으로 초기화

        else if (datatype == "object")
            self.obj[item_name] = {};   // object는  {} 으로 초기화

    });
} 

export default {
    mixins: [slip, common, lucoms],
    props: ['custParam'],
    components: {AgGridVue},
    data() {
        return {
            textarea1: '',
            bankCd: '01',
            form: {
                custNm : '',
                custType : 'Default',
                propensity : 'Default',
                propensityBigo: '', 
                positionNm: '', 
                hpNo: '', 
                officeTelNo: '', 
                etcTelNo1: '', 
                etcTelNo2: '', 
                boundTelNo: '', 
                smsYn: 'Y', 
                telYn: '',
                addr1: '', /** 주소1 */
                addr2: '', /** 주소2 */
                zipCd: '',
                zipCd1: '',
                juminNo: '',
                inType: '0',
                
                orderId: '', /** 주문번호 */     
                orderTelNo: '',        
                orderDt: this.$moment().format('YYYY-MM-DD HH:mm:ss'), /** 주문일시 */
                orderAmt: '0', /** 청구금액 */
                orderCustNm: '', /** 주문자명 */
                payBank: '', /** 입금은행 */
                payAccount: '', /** 계좌번호 */
                telNo: '', /** 연락처 */
                deliveryNm: '', /** 받을사람 */
                deliveryTelNo: '', /** 전화번호 */
                deliveryHpNo: '', /** 핸드폰 */
                memo: '', /** 주문메모 */
                billYn: '' /** 계산서 발생유무 */
            },
            data: [],
            subData: [],
            payBankOpt: [], /** 입금은행 */
            billYnRadio: [], /** 계산서 발생유무 */
            qtyChangeCnt: 0,
            orderAmt: '0', /** form.orderAmt에 값이 watch에서 갱신이 안되어서 추가로 넣음. */
            bReadOnly: false,
            showSave: true, /** 저장버튼 표시여부 */

            // AG-GRID OPTION [START]
            gridStyle : 'padding-top: 40px; width: 100%;height: 300px; min-height:100px;',
            defaultColDef: {
                resizable: true
                , filter: true
                , sortable: true
            },
            mainGridApi: null,
            mainColumnApi: null,
            subGridApi: null,
            subColumnApi: null,
            columnDefs: [],
            subColumnDefs: [],
            mainGridOptions: {
                enableColResize: true,
                enableFilter: true,
                animateRows: false,
                enableSorting: true,
            },
            subGridOptions: {
                enableColResize: true,
                enableFilter: true,
                animateRows: false,
                enableSorting: true,
            },
            frameworkComponent : {
                datePicker: DatepickerCellRenderer,
                maskEdit: MaskEditCellRenderer,
                select: SelectCellRenderer,
                checkBox: CheckboxCellRenderer,
                radio: RadioCellRenderer,
                numberInput: NumberInputCellRender,
                input: InputCellRender,
                button: ButtonCellRenderer
            },
            //AG-GRID OPTION [END]
        }
    },
    watch:{
        qtyChangeCnt(){
            console.log('watch start==')
            this.calcAmt()
        }
    },
    mounted() {
        this.getCombo({flag: 'INIT'});
        this.showSave = true;

        this.calcAmt();
        this.form.orderDt = this.$moment().format('YYYY-MM-DD HH:mm:ss') /** 주문일시 */
        this.setOrderList({});
        
         
        this.searchOrderList();
    
        //==세션설정=================================
        const vOderConsult = JSON.parse(sessionStorage.getItem(this.$parent.asSessionKey + "orderConst"))
        //console.log('mount vOderConsult: ', vOderConsult)
        
        if(vOderConsult && vOderConsult.loginId === this.$store.state.loginInfo.loginId){
            this.data = vOderConsult.data ? JSON.parse(JSON.stringify(vOderConsult.data)): [] 
            this.form = JSON.parse(JSON.stringify(vOderConsult.form)) || {}
        
        } else {
            
            if(vOderConsult){
                sessionStorage.removeItem(this.$parent.asSessionKey + "orderConst")      // 초기화
            }
        }

        if(this.custParam.applySearchCond){
            // search 컴포넌트의 조회조건 적용 : sessionStorage보다 search변경이 우선
            this.applySearchCond(this.custParam.applySearchCond);
            delete this.custParam.applySearchCond;
        }
        
    },
    methods: {
        onReadyMain() {
            this.mainGridApi = this.mainGridOptions.api;
            this.mainColumnApi = this.mainGridOptions.columnApi;
            this.createMainColumnDefs();
        },
        onReadySub() { 
            //메인그리드 api 정의
            this.subGridApi = this.subGridOptions.api;
            this.subColumnApi = this.subGridOptions.columnApi;
            this.createSubColumnDefs();
        },
        createMainColumnDefs() {
            const vm = this;
            this.columnDefs = [
                {
                    headerName:'선택',
                    field:'chk', 
                    width:80,
                    cellStyle:{textAlign: 'center'},
                    cellRenderer: 'checkBox',
                    ellRendererParams: {
                          trueValue: 'Y'    //true값  지정 defalut-"Y" ex) "Y", true, "1"
                        , falseValue: 'N'  //false값 지정 defalut-"N" ex) "N", false, "0"
                        , disable: true
                    },
                },
                {
                    headerName:'No',
                    field:'순번', 
                    width:80,
                    cellStyle:{textAlign: 'center'},
                    valueFormatter: function(params) {               
                        return params.node.rowIndex+1;
                    }
                },
                {
                    headerName:'제조사',
                    field:'makerNm', 
                    width:130,
                    cellStyle:{textAlign: 'center'},
                },
                {
                    headerName:'제품군',
                    field:'itemGroupNm', 
                    width:130,
                    cellStyle:{textAlign: 'center'},
                },
                {
                    headerName:'모델명',
                    field: 'modelNm',
                    width:160,
                    cellStyle:{textAlign: 'center'}
                },
                {
                    headerName:'상품코드',
                    field:'itemCd', 
                    width:150,
                    cellStyle:{textAlign: 'center'},
                },
                {
                    headerName:'상품명',
                    field:'itemNm', 
                    width:250,
                    cellStyle:{textAlign: 'center'},
                },
                {
                    headerName:'단가',
                    field:'unitPrice3', 
                    width:130,
                    cellStyle:{textAlign: 'right'},
                    valueFormatter: (params) => {
                        return vm.getNumberFormat(params.value);
                    }
                },
                {
                    headerName:'수량',
                    field:'qty', 
                    width:110,
                    editable: true,
                    cellStyle:{textAlign: 'right', backgroundColor: '#fff8f7'},
                    valueFormatter: (params) => {
                        return vm.getNumberFormat(params.value);
                    }
                },
                {
                    headerName:'금액',
                    field:'amt', 
                    width:130,
                    cellStyle:{textAlign: 'right'},
                    valueFormatter: (params) => {
                        return vm.getNumberFormat(params.value);
                    }
                },
                {
                    headerName:'상품코드',
                    field:'itemId', 
                    hide: true,
                    width:110,
                    cellStyle:{textAlign: 'center'},
                }
            ];
        },
        createSubColumnDefs() {
            const vm = this;
            this.subColumnDefs = [
                {
                    headerName: '주문일자', 
                    field:'createDt', 
                    width: 130,
                    cellStyle:{textAlign:'left'},
                    cellRenderer: (params) => {
                        return `<div style="text-decoration: underline; text-underline-position: under; color:blue; cursor:pointer;">${vm.getDateFormat(params.value)}</div>`;
                    },
                },
                {
                    headerName: '주문자명', 
                    field:'boundCustNm', 
                    width: 150,
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '상품코드', 
                    field:'itemCd', 
                    width: 150,
                },
                {
                    headerName: '상품명', 
                    field:'itemNm', 
                    width: 220,
                },
                {
                    headerName: '받을사람', 
                    field:'deliveryNm', 
                    width: 150,
                },
                {
                    headerName: '주소', 
                    field:'addr', 
                    width: 300,
                },
                {
                    headerName: '입금일자', 
                    field:'payConfirmDt', 
                    width: 130,
                },
                {
                    headerName: '배송일자', 
                    field:'deliveryDt', 
                    width: 130,
                },
                {
                    headerName: '주문취소', 
                    field:'cancelQty', 
                    width: 130,
                    cellStyle:{textAlign:'right'}
                },
                {
                    headerName: '접수자', 
                    field:'creatorNm', 
                    width: 130,
                },
                {
                    headerName: '주문번호', 
                    field:'orderId', 
                    hide: false,
                    width: 130,
                },
                {
                    headerName:'계산서발행유무',
                    field:'billYn', 
                    hide: false,
                    width:110,
                    cellStyle:{textAlign: 'center'},
                },
            ];
        },
        onItemCellClicked(params) {
            //const idx = params.rowIndex;
            const field = params.colDef.field;
        },
        onItemCellValueChange(params){
            const field = params.colDef.field;
//            console.log('onItemCellValueChange params : ', field, params)
            const regex = /[^0-9]/g

            if(field === 'qty'){
                let vQty = JSON.stringify(params.data.qty)
                vQty = params.data.qty.replace(regex, '')
                const vUnitPrice3 = params.data.unitPrice3.replace(regex, '')
                params.data.qty = vQty

                if(!(isNaN(vQty))){
                    if(!(isNaN(vUnitPrice3))){
                        params.data.amt = comma(vUnitPrice3 * vQty)
                        this.mainGridApi.redrawRows({ rowNodes: params });
                    }
                }
                this.calcAmt()
                this.qtyChangeCnt++
            }
        },
        onSubCellClicked(param) {
            //const idx = param.rowIndex;
            const field = param.colDef.field;
            console.log('onSubCellClicked param: ',  param)
            if(field === 'createDt'){
                this.openCustSelectModel(param.data);
            }
        },
        calcAmt(){
            let vSumAmt = 0;
            this.data.map(x=>{
                let v1 = x.amt ? x.amt : '0';
                v1 = v1.replace(/[^0-9]/g, "");
                // console.log('vSumAmt v1: ', v1);
                vSumAmt += Number(v1);
                // console.log('vSumAmt v2: ', vSumAmt);
                return x;
            })
// console.log('calcAmt vSumAmt: ', vSumAmt);
            this.form.orderAmt = comma(vSumAmt);
            this.orderAmt = comma(vSumAmt);
        },
        openModel() {
            /** 구입상품입력추가 */

            let vm = this;
            this.$modal.open({
                width: 800,
                component: InvtItemSelect,
                parent: this,
                props: {
                    data: {
                        centerCd: '01',
                        prodCd1: '',
                        prodCd2: '',
                        gb: '구분코드',
                        prodNo: '품번'
                    }
                },
                events: {
                    close(vRetData) {
                        console.log('close', vRetData);
                        let allItemIds = '' // 기존의 품목ID들
                        vm.data.map(x=>{
                            allItemIds += x.itemId + ',' 
                            return x
                        })

                        //이미 추가한 품목은 제외시킴
                        let vvRetData2 = (allItemIds === '') ? vRetData : ( vRetData.filter(x=>allItemIds.indexOf(x.itemId + ',') == -1) )

                        const vData = vvRetData2.map(x=>{
                            x.qty = 1
                            x.amt = x.unitPrice3 ? x.unitPrice3 : ''
                            x.amt = comma(x.amt)
                            x.unitPrice3 = comma(x.unitPrice3)

                            return x
                        }) || []

                        console.log(' vm.data: ', vm.data)
                        console.log(' vData: ', vData)
                        const vSumArr = vm.data.concat(vData)
                        console.log(' vSumArr: ', vSumArr)
                        vm.data = vSumArr

                        vm.calcAmt()
                        vm.qtyChangeCnt++


                        console.log('close 33: ', vm.data);
                        
                    },
                }
            });
        },
        openCustSelectModel(param) {
            console.log("openCustSelectModel", param)
            let vm = this;
            this.$modal.open({
                width: 980,
                component: OrderRead,
                parent: this,
                props: {
                    data: param
                },
                events: {
                    close(data) {
                        console.log('close', data);
                    },
                }
            });
        },
        deleteItem() {
            /** 구입상품 삭제처리  */
            var list = this.data.filter(v => v.chk === 'Y')
            
            if(list.length == 0){
                this.$swal({
                    type: 'warning',
                    text: '삭제할 자재를 선택해 주십시요.'
                });

                return false
            }

            const vm = this
            const vData = vm.data.filter(v => v.chk === 'N')
            vm.data = JSON.parse(JSON.stringify(vData))

            vm.calcAmt()
            vm.qtyChangeCnt++

        },
        async getCombo(param) {
            if(param.flag === 'INIT'){
                // 결제은행 : PayBank 2레벨
                const runA = this.$http.get(`/api/codeMng/combo`, {params: {parentId: 106}})
                    .then(response => {
                        this.payBankOpt = response.data || []
                        this.payBankOpt.unshift({key:'', value:'선택'})
        
                    });
                
                // 계산서발행유무 : BillYn 2레벨
                const runB = this.$http.get(`/api/codeMng/combo`, {params: {parentId: 131}})
                    .then(response => {
                        this.billYnRadio = response.data || []
                    });    
                
                this.$store.commit('loading');

                await Promise.all([runA, runB]);
                
                this.$store.commit('finish');    
            }
        },
        save() {
            /** 주문상담 저장 */

            if(!this.$parent.$refs.refSearchForm.custValidate()){
                // searchForm의 조회조건 체크
                return false;
            }

            if(this.data.length == 0){
                this.$swal({ type: 'warning', text: '하나 이상의 구입상품을 등록해 주십시오.' });
                return false
            }

            // const vChkObj = this.data.filter(x=>x.chk==='Y');
            // if(vChkObj.length == 0){
            //     this.$swal({ type: 'warning', text: '저장할 구입상품을 체크해 주십시오.' });
            //     return false
            // }
            
            let emptyQtyNo = ''
            const list = this.data.filter(v => v.qty === '').map((x, idx)=>{
                emptyQtyNo += idx > 0 ? ', ' : ''
                emptyQtyNo += x.no
            })
            
            if(emptyQtyNo != ''){
                const vmsg = emptyQtyNo + '번 구입상품의 대수를 정확하게 입력해 주십시오.'
                this.$swal({ type: 'warning', text: vmsg });
                return false
            }

            emptyQtyNo = ''
            const list2 = this.data.filter(v => v.qty === '0').map((x, idx)=>{
                emptyQtyNo += idx > 0 ? ', ' : ''
                emptyQtyNo += x.no
            })
            
            if(emptyQtyNo != ''){
                const vmsg = emptyQtyNo + '번 AS접수제품의 대수에 1개 이상의 값을 입력해 주십시오.'
                this.$swal({ type: 'warning', text: vmsg });
                return false
            }
       
            if(this.form.payBank === undefined || this.form.payBank === ''){
                const vmsg = '입급은행을 선택해 주십시오.'
                this.$swal({ type: 'warning', text: vmsg });
                return false
            }

            if(this.form.billYn === undefined || this.form.billYn === ''){
                const vmsg = '계산서발행여부를 선택해 주십시오.'
                this.$swal({ type: 'warning', text: vmsg });
                return false
            }
            
            if(this.custParam.zipCd1 === '' && this.form.zipCd1 === ''){
                const vmsg = '고객 우편번호1 또는 배송지 우편번호1을 입력해 주십시오.'
                this.$swal({ type: 'warning', text: vmsg });
                return false
            }

            
            let vCustAddr1 = this.$parent.search.addr1;
            let vCustAddr2 = this.$parent.search.addr2;
            let vJuminNo = '';
            const vCustObj = this.custParam.callCustSelPageList;
            if(vCustObj && vCustObj.length > 0){
                vJuminNo = vCustObj[0].juminNo || '';
            }
            
            if(vCustAddr1 === '' && this.form.addr1 === ''){
                const vmsg = '고객 주소1 또는 배송지 주소1을 입력해 주십시오.';
                this.$swal({ type: 'warning', text: vmsg });
                return false;
            }

            if(vCustAddr2 === '' && this.form.addr2 === ''){
                const vmsg = '고객 주소2 또는 배송지 주소2을 입력해 주십시오.';
                this.$swal({ type: 'warning', text: vmsg });
                return false;
            }

            let vOrderAmt = this.form.orderAmt;
            vOrderAmt = vOrderAmt && typeof(vOrderAmt)=='string' ? vOrderAmt.replace(/[^0-9]/g, '') : vOrderAmt;

            let vData = JSON.parse(JSON.stringify(this.data));
            vData.map(x=>{
                x.orderDetailId = '';
                x.amt = x.amt && typeof(x.amt)=='string' ? x.amt.replace(/[^0-9]/g, '') : x.amt;
                x.qty = x.qty && typeof(x.qty)=='string' ? x.qty.replace(/[^0-9]/g, '') : x.qty;
                x.unitPrice = x.unitPrice3 && typeof(x.unitPrice3)=='string' ? x.unitPrice3.replace(/[^0-9]/g, '') : x.unitPrice3;

                return x;
            })
            
            const vBillYn = this.form.billYn === '유' ? 'Y' : 'N';
         
            let vSaveform0 ={
                ...this.form,
                ...this.$parent.search, /** 조회조건 */
                juminNo: vJuminNo,
                zipCd: this.$parent.search.zipCd1 || '',
                orderId: this.form.orderId || '',
                orderTelNo: this.form.orderTelNo || '',
                orderDt: this.form.orderDt || '',
                orderCustNm: this.form.orderCustNm || '',
                payBank: this.form.payBank || '',
                memo: this.form.memo || '',
                custNm:  this.$parent.search.custNm || '',
                orderAmt: vOrderAmt || '', 
                payAccount: this.form.payAccount || '',
                deliveryNm: this.form.deliveryNm ? this.form.deliveryNm : this.$parent.search.custNm,
                deliveryTelNo: this.form.deliveryTelNo ? this.form.deliveryTelNo : this.$parent.search.telNo,
                deliveryHpNo: this.form.deliveryHpNo ? this.form.deliveryHpNo : this.$parent.search.hpNo,
                deliveryZipCd: this.form.zipCd1,
                deliveryAddr1: this.form.addr1,
                deliveryAddr2: this.form.addr2,
                orderItemList: vData || [],
                billYn: vBillYn
            };
            
            const regex = /[^0-9]/g

            vSaveform0.telNo = vSaveform0.telNo ? vSaveform0.telNo.replace(regex, '') : '';
            vSaveform0.boundTelNo = vSaveform0.boundTelNo ? vSaveform0.boundTelNo.replace(regex, '') : '';
            vSaveform0.hpNo = vSaveform0.hpNo ? vSaveform0.hpNo.replace(regex, '') : '';
            vSaveform0.chargeHpNo = vSaveform0.chargeHpNo ? vSaveform0.chargeHpNo.replace(regex, '') : '';
            vSaveform0.orderTelNo = vSaveform0.orderTelNo ? vSaveform0.orderTelNo.replace(regex, '') : '';
            vSaveform0.deliveryTelNo = vSaveform0.deliveryTelNo ? vSaveform0.deliveryTelNo.replace(regex, '') : '';
            vSaveform0.deliveryHpNo = vSaveform0.deliveryHpNo ? vSaveform0.deliveryHpNo.replace(regex, '') : '';

            vSaveform0 = JSON.parse(JSON.stringify(vSaveform0));
            const vSaveform = vSaveform0;

            console.log('vSaveform : ', vSaveform);

            this.$swal({
                type: 'warning',
                text: `주문상담내역을 저장 하시겠습니까?`,
                showCancelButton: true,
                confirmButtonText: '예',
                cancelButtonText: '아니오',
            }).then((result) => {
                if (result.value) {
                    this.$store.commit('loading')
                    this.$http.put(("/api/asMng/call/saveOrderConsult"), vSaveform)
                        .then(response => {
                            let vMsgStr = '주문상담이력이 등록되었습니다.';
                            if(response && response.data[0] == 'UPDATE_OK'){
                                vMsgStr = '주문상담이력이 수정되었습니다.';
                            }

                            this.$swal({ type: 'success', text: vMsgStr });

                            // 초기화
                            this.$parent.$refs.refSearchForm.initCust('NO_ALERT');

                        }).catch((e) => {
                            console.error(e);
                            this.$swal({ type: 'success', text: '주문상담이력 저장에 실패 했습니다.' });
                        })
                        .finally(() => {
                            this.$store.commit('finish');
                        });

                }
            });

            
        },
        applySearchCond(pObj){
            // 접수관리메뉴의 상단 조회조건이 있을경우 그 값으로 셋팅
            let vObj = pObj ? pObj : this.custParam.popHeadInfo;
            console.log(' order applySearchCond vObj: ', vObj)
            if(vObj){
                this.form.orderCustNm = vObj.custNm; // 주문자명
                
                let vHpNo = vObj.boundTelNo || '';
                if(vHpNo === ''){
                    vHpNo = vObj.hpNo || '';
                }
                if(vHpNo === ''){
                    vHpNo = vObj.telNo || '';
                }
                this.form.orderTelNo = vHpNo; // 연락처

                let vTelNo = vObj.telNo || '';
                this.form.deliveryTelNo = vTelNo; // 전화번호
                if(vTelNo === ''){
                    this.form.deliveryTelNo = vHpNo; // 전화번호
                }
                
                this.form.deliveryHpNo = vHpNo; // 핸드폰
                this.form.deliveryNm = vObj.custNm; // 받을사람
                this.form.zipCd1 = vObj.zipCd1; // 
                this.form.addr1 = vObj.addr1; // 
                this.form.addr2 = vObj.addr2; //   
            }
            
        },
        async searchOrderList(pCustId){
            /** 주문상담이력 조회 */
           

            console.log('searchOrderList this.custParam: ', this.custParam);
            let vObj = this.custParam;
            
            let vCustId = ''
            if(pCustId){
                vCustId = pCustId;
            } else {
                if(vObj.callCustSelItemList && vObj.callCustSelItemList.length>0){
                    vCustId = vObj.callCustSelItemList[0].custId || ''
                    if(vCustId === ''){
                        this.data = [];
                        this.subData = [];

                        return false;
                    }
                } else {
                    this.data = [];
                    this.subData = [];

                    return false;
                }
            }
            
            const vform = {
                custId: vCustId,
                sortType: '',
                page: 1,
                totalpage: 9999,
                totalcount: 9999,
                curPage: 0,
                processTime: ''
            }
            this.$store.commit('loading')
            console.log('searchOrderList : ', vform) 
            await this.$http.post(("/api/asMng/call/searchOrderList"), vform
                ).then(response => {
                console.log('Order select: ' , vform.inType , response.data)

                this.subData = response.data.map(x=>{
                    x.addr = x.addr1 + ' ' + (x.addr2 || '');
                    x.createDt = (x.createDt && x.createDt.length >= 19) ? x.createDt.substring(0,19) : (x.createDt || '');
                    
                    return x
                })
            }).finally(() => {
                this.$store.commit('finish')
            });
        },
        setOrderList(param){
            console.log('setOrderList start param: ', param);
            
            let vCustObj = param ;
            if(!param){
                vCustObj = this.custParam ? this.custParam.popHeadInfo : {};
                vCustObj.inType = this.custParam ? this.custParam.inType : '';
                vCustObj.inTypeVal = this.custParam ? this.custParam.inTypeVal : '';
            }
            console.log('setOrderList param: ', param);
            
            this.applySearchCond(vCustObj); 
            this.enableChk(vCustObj.inType);
            const vCustId = vCustObj.callCustSelItemList && vCustObj.callCustSelItemList.length>0 ? vCustObj.callCustSelItemList[0].custId : '';

            this.searchOrderList(vCustId);
        },
        enableChk(param){
            /** 입력항목 활성화처리 */
            console.log('enableChk start :', param);
            this.showSave = true;

            this.form.inType = param;

            if(param === 'IN_CALL_ID'){
                // if(this.form.callType === 'Processing'){
                //     // 처리결과가 미완료이면 수정가능해야 함.
                //     this.bReadOnly = false;
                // } else {
                //     this.bReadOnly = true;
                // }
            } else if(param === 'IN_AS_ID'){
                this.showSave = false; // 저장버튼 숨김.    
            } else {
                this.bReadOnly = false;
            }
        },
        addrOpenPopUp(param) {
            const vm = this;

            let vOparam = {};
            if(param === 'ZIP'){
                vOparam = {q: this.form.addr1 + ' ' + this.form.addr2}
            }

            // eslint-disable-next-line no-undef
            new daum.Postcode({
                oncomplete: (data) => {

                    var fullAddr = data.address; //최종 주소 변수
                    var extraAddr = ''; // 조합형 주소 변수
              
                    if(data.userSelectedType === 'R') {
                        if(data.bname) {
                            extraAddr += data.bname;
                        }
                        if(data.buildingName) {
                            extraAddr += (extraAddr ? ', '+ data.buildingName : data.buildingName);
                        }
                        fullAddr += (extraAddr ? ' ('+ extraAddr + ')' : '');
                    } else {
                        fullAddr = data.jibunAddress;
                    }
                    
                    vm.form.zipCd1 = data.zonecode;
                    vm.form.addr1 = fullAddr;
                    vm.form.addr2 = ''; // 초기화
                    // vm.goOpen(param);
                }
            }).open(vOparam);
        }
    }
}
</script>